/**
 * `GET /v1/usage` and tRPC `usage.current` — the current window's counters, `TR:868`.
 */
import { z } from "zod";
import { ROLLED_UP_METRICS, USAGE_WINDOW } from "../usage.js";
export const usageViewSchema = z.object({
    /** `2026-10`. */
    window: z.string().regex(USAGE_WINDOW),
    /** Where `resolver_requests` counts from: the window's start, or a plan change — `usageFloor`. */
    requestsCountedFrom: z.iso.datetime(),
    /**
     * One row per metric the rollup has counted this window. Empty before the first rollup,
     * which is why the attention card's usage check is absent rather than clear then.
     */
    counters: z.array(z.object({
        metric: z.enum(ROLLED_UP_METRICS),
        value: z.number().int().nonnegative(),
        /** `PLANS[plan]`'s figure. `null` where the plan has none (Enterprise's requests). */
        limit: z.number().int().nullable(),
        countedAt: z.iso.datetime(),
    })),
});
//# sourceMappingURL=usage.js.map